<template>
  <VpShell :aside="false">
    <VpFeature the-key="QUICK_REPLY" #default="{ feature }">
      <router-view :feature="feature" />
    </VpFeature>
  </VpShell>
</template>

<script>
export default {};
</script>
